export default "__VITE_ASSET__CzA4AMLA__"